// extracted by mini-css-extract-plugin
export default {"socialButtonLink":"socialButton_socialButtonLink__87ehH","socialButton":"socialButton_socialButton__IdWmf"};